import { retrieveTokens } from "$api/tokenManagement";

const tokenInterceptor = (config) => {
  const { token } = retrieveTokens();
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  };
};

export default tokenInterceptor;
